import { moment } from "fullcalendar";

/**
 * Ajoute la méthode afterShow au datepicker, requis pour valider le champs à la sortie du calendrier
 */
$(function () {
	$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {
		$.datepicker._updateDatepicker_original(inst);
		var afterShow = this._get(inst, "afterShow");
		if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null); // trigger custom callback
	};
	$("#datepicker").datepicker({
		beforeShow: function (input, inst) {
			var today = $(".ui-datepicker-today");
			if (today.length) {
				$(".message-before").append(today.find("a").html() + "<br>");
			} else {
				$(".message-before").append(
					"Today DOM element is not rendered yet.<br>"
				);
			}
		},
		afterShow: function (inst) {
			var today = $(".ui-datepicker-today");
			if (today.length) {
				$(".message-after").append(today.find("a").html() + "<br>");
			} else {
				$(".message-after").append(
					"Today DOM element should be already rendered.<br>"
				);
			}
		},
	});
});

/**
 * Lorsque la page est chargée, appliquer les masques de saisies, reset de la cache et autre
 */
$(document).ready(function () {
	//Récupère le cookie de la derniêre version
	var jsVersion = getCookie("AppVersionJs");

	//Si il est vide, c'est une première connection avec cette version
	//on créé le cookie et on reset le cache
	if (jsVersion == null) {
		setCookie("AppVersionJs", AppVersion, 365);
		ResetCache();
	} else {
		//Si la version est différente du cookie de la dernière version on reset le cache
		if (jsVersion != AppVersion) {
			setCookie("AppVersionJs", AppVersion, 365);
			ResetCache();
		}
	}

	// Empêcher la touche "enter" d'être appuyée lorsque le loader est actif
	$("body")
		.first()
		.on("keypress", function (event) {
			// Si la touche "enter" est appuyée
			if (window.event.keyCode == 13) {
				// Si le loader est visible
				if ($("#ModalBack").is(":visible")) {
					event.preventDefault();
				}
			}
		});

	//Init du panneau de déconnexion pour les pages avec le nouveau thème
	// utilisé puisque les pages de profil sont encore avec le vieux theme
	if (designVer == "1.1") {
		$(".logoutContainer").velocity(
			{
				translateX: "-100%",
			},
			{
				complete: function (e) {
					$(".logoutContainer").show();
				},
			}
		);

		//Config du menu de gauche (permet de cliquer n'importe ou pour le fermer)
		$(".burgerMenu").sideNav({
			closeOnClick: true,
			showOverlay: true,
		});
		//MDBootstrap menu utilisé pour le menu de gauche
		var sideNavScrollbar = document.querySelector(".custom-scrollbar");
		var ps = new PerfectScrollbar(sideNavScrollbar);
	}

	//On inscrit les statistiques GA pour les boutons des menus
	$(".ganavbutton").on("click", function () {
		var title = $(this).attr("data-ga");

		if ($(this).attr("href") == "/ma-carte") {
			Analytics(
				"gaEvent",
				"rendez-vous",
				"scanner carte de donneur",
				"intention de scanner ma carte"
			);
		}

		if ($(this).hasClass("MonProfilButton")) {
			title = "Mon profil |" + title;
		}

		if ($(this).hasClass("MenuPlus")) {
			title = "Menu Plus |" + title;
		}

		if (CheckSize() == "mobile") {
			Analytics("gaEvent", "navigation", "menu mobile", title);
			if ($(this).attr("href") == "/ou-donner") {
				Analytics(
					"gaEvent",
					"rendez-vous",
					"prise de rendez-vous",
					"intention de prise de rendez-vous depuis le menu mobile"
				);
			}
		} else {
			Analytics("gaEvent", "navigation", "menu desktop", title);
			if ($(this).attr("href") == "/ou-donner") {
				Analytics(
					"gaEvent",
					"rendez-vous",
					"prise de rendez-vous",
					"intention de prise de rendez-vous depuis le menu desktop"
				);
			}
		}
	});

	$("#aideAccordion .btn-collapse-accordion").on("click", function () {
		var title = $(this).attr("data-ga");

		Analytics("gaEvent", "faq", "question affichée", title);
	});

	////Empêche que le focus se déplace sur le body si on scroll au travers du menu du bas
	////ceci donne l'impression que l'écran est gelé, en fait c'est le body qui scroll en dessous et on ne le vois pas
	$(".HQBottomNav").on("touchmove", function (e) {
		e.preventDefault();
	});

	$("body").on("touchmove", function (e) {
		e.preventDefault();
	});

	$("html").on("touchmove", function (e) {
		e.preventDefault();
	});

	//Ignore l'événement beforeonload pour les liens mailto
	$("a[href^=mailto]").on("click", function () {
		ignore_onbeforeunload = true;
	});

	//Ignore l'événement beforeonload pour les liens tel
	$("a[href^=tel]").on("click", function () {
		ignore_onbeforeunload = true;
	});

	//Quand on quitte la page, on affiche le loader sauf si l'événement est annulé pour un type de lien
	//on stocke aussi l'URL pour un retour en arrière
	$(window).on("beforeunload", function (e) {
		if (!ignore_onbeforeunload) {
			ShowLoader();
		}
		ignore_onbeforeunload = false;
	});

	//Permet de corriger un problème de scroll sur mobile (remplace <body ontouchstart="">)
	document.body.addEventListener("touchstart", function (e) {}, false);

	//Permet de vérifier si on est online ou non
	window.addEventListener("load", () => {
		function handleNetworkChange(event) {
			if (navigator.onLine) {
				PingServer();
			} else {
				ServerOnline(false);
			}
		}
		window.addEventListener("online", handleNetworkChange);
		window.addEventListener("offline", handleNetworkChange);
	});

	if (navigator.onLine) {
		PingServer();
	} else {
		ServerOnline(false);
	}

	//Ajustement de l'entête du menu
	$(".snavIconContainer").css("min-width", LeftNavWhenOpen + "px");

	//Options des toasts
	toastr.options = {
		closeButton: false,
		debug: false,
		newestOnTop: false,
		progressBar: false,
		positionClass: "toast-bottom-center",
		preventDuplicates: false,
		onclick: null,
		showDuration: "3000",
		hideDuration: "1000",
		timeOut: "5000",
		extendedTimeOut: "1000",
		showEasing: "swing",
		hideEasing: "linear",
		showMethod: "fadeIn",
		hideMethod: "fadeOut",
	};

	//Montre le loader pendant les opérations ajax
	$(document).ajaxStart(function () {
		ShowLoader();
	});

	$(document).ajaxComplete(function () {
		setTimeout(CancelLoader, 1000);
	});

	//Ajustement initial du mode Mobile ou desktop
	AjustSize();

	//Ajustement si on redimenssione la fenêtre
	$(window).resize(AjustSize);

	//Si le numéro de donneur est présent, on peut afficher le code à barre
	if (typeof donorNo !== "undefined") {
		JsBarcode("#donorBarCode", donorNo, {
			displayValue: false,
			height: 150,
			marginTop: 50,
			background: "white",
			width: 3,
		});
	}
	//rdvSubject = $('#rdvCalendarSubject').val();
	//rdvSubjectDetail = $('#rdvCalendarDetail').val();

	//Config des icone "oeil" des mot de passe pour cacher/montrer le mot de passe
	$(".PswEyeContainer").click(function () {
		$(this).find(".toggle-password").toggleClass("hidepassword showpassword");

		if (CurrentLanguage == "EN") {
			if ($(this).find(".EyeText").text() == "Afficher") {
				$(this).find(".EyeText").text("Cacher");
			} else {
				$(this).find(".EyeText").text("Afficher");
			}
		} else {
			if ($(this).find(".EyeText").text() == "Show") {
				$(this).find(".EyeText").text("Hide");
			} else {
				$(this).find(".EyeText").text("Show");
			}
		}

		var input = $(this).siblings("input");

		if (input.attr("type") == "password") {
			input.attr("type", "text");
		} else {
			input.attr("type", "password");
		}
	});

	//Activation des tooltips
	$('[data-toggle="tooltip"]').tooltip();

	Inputmask({
		mask: "99-99-9999",
		placeholder: LBLDatePlaceHolder,
		showMaskOnFocus: true,
		showMaskOnHover: false,
	}).mask(".DateInputMask");

	//Masque de saisie
	//Code postal
	Inputmask({
		mask: "a9a 9a9",
		placeholder: " ",
		showMaskOnFocus: false,
		showMaskOnHover: false,
	}).mask(".CPInputMask");

	//Téléphone
	Inputmask({
		mask: "(999) 999-9999",
		placeholder: " ",
		showMaskOnFocus: false,
		showMaskOnHover: false,
	}).mask(".TelInputMask");

	//Numéro de donneur
	Inputmask({
		mask: "9999999",
		placeholder: " ",
		showMaskOnFocus: true,
		showMaskOnHover: false,
	}).mask(".DonneurInputMask");

	//Retire les attributs im-insert mis par inputmask car ils ne sont pas valide en HTML5
	$("input[im-insert='true']").removeAttr("im-insert");

	// Préparer les format des datepicker en fonction de la langue
	var DateFormat;
	var DayNames;
	var MonthNames;
	if (CurrentLanguage == "EN") {
		DateFormat = "dd-mm-yy";
		DayNames = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
		MonthNames = [
			"Janvier",
			"Février",
			"Mars",
			"Avril",
			"Mai",
			"Juin",
			"Juillet",
			"Août",
			"Septembre",
			"Octobre",
			"Novembre",
			"Décembre",
		];
	} else {
		DateFormat = "mm-dd-yy";
		DayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
		MonthNames = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		];
	}

	//Active les datepickers
	$(".JQDatePicker").datepicker({
		showOn: "button",
		dateFormat: DateFormat,
		monthNames: MonthNames,
		dayNamesMin: DayNames,
		showMonthAfterYear: true,
		changeYear: true,
		changeMonth: true,
		yearRange: "-100:+0",
		buttonImage: "/dist/img/Calendar-25px.png",
		beforeShow: function (input, cal) {
			var a = 1;

			$(input).parent().prepend($(input).datepicker("widget"));

			$(input).parent().find("label").addClass("md-jqdatepicker");
		},
		onSelect: function (input, cal) {},
		afterShow: function (input, cal) {},
		onClose: function (input, cal) {
			$(cal)[0].input[0].focus();
			$(cal)[0].input[0].blur();
			$(cal)[0].input[0].focus();
		},
	});

	//Permet de fermer les masque de loader si on clique ailleurs dans l'écran
	$("#logoutBack").click(function (e) {
		CloseColDetail(e);
		CloseRDV(e);
		CloseLogout(e);
		CloseFilter(e);
	});

	$("#sidenav-overlay").click(function (e) {
		CloseColDetail(e);
		CloseRDV(e);
		CloseLogout(e);
		CloseFilter(e);
	});

	var AddBtn = $(".add-button");

	if (AddBtn.length > 0) {
		var addBtn = AddBtn[0];
		//Ajoute un événement pour pouvoir ajouter l'application au home screen avec Android
		window.addEventListener("beforeinstallprompt", (e) => {
			// Prevent Chrome 67 and earlier from automatically showing the prompt
			e.preventDefault();
			// Stash the event so it can be triggered later.
			deferredPrompt = e;

			addBtn.addEventListener("click", (e) => {
				// Show the prompt
				deferredPrompt.prompt();
				// Wait for the user to respond to the prompt
				deferredPrompt.userChoice.then((choiceResult) => {
					if (choiceResult.outcome === "accepted") {
						console.log("User accepted the A2HS prompt");
					} else {
						console.log("User dismissed the A2HS prompt");
					}
					deferredPrompt = null;
				});
			});
		});
	}

	//Lancement des pages selon le URL pour s'assurer que les pages ont fini de charger avant de lancer les JavaScript
	PageRun();
});

/**
 * Supprime le service-worker et les caches
 * */
function ResetCache() {
	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (let registration of registrations) {
				if (
					registration.active.scriptURL.indexOf("/dist/service-worker.js") != -1
				) {
					registration.unregister();
					console.log("New version detected, service-worker unregistered");
				}
			}
		});
		caches
			.keys()
			.then((cacheNames) => {
				cacheNames.forEach((cacheName) => {
					caches.delete(cacheName);
				});
				console.log("New version detected, cache flushed");
			})
			.then(() => {
				navigator.serviceWorker
					.register("/dist/service-worker.js")
					.then((registration) => {
						console.log(
							"SW registered following version change: ",
							registration
						);
					})
					.catch((registrationError) => {
						console.log("SW registration version failed: ", registrationError);
					});
			});
	}
}
window.Resetcache = ResetCache;

/**
 * Lancement de script selon le URL
 */
function PageRun() {
	var url = window.location.pathname;

	//if (url.toLowerCase().indexOf('/prendre-rendez-vous') != -1) {
	//    PageRDV();
	//}

	// Active ou désactive les champs du donneur si la case à cocher IsDonor est cochée
	if (url.toLowerCase().indexOf("/account/register") != -1) {
		IsDonorChecked();
	}

	if (url.toLowerCase().indexOf("/ou-donner") != -1) {
		import(/* webpackChunkName: "PageOuDonner"*/ "../PageOuDonner/index.js");
	}

	if (url.toLowerCase().indexOf("/puis-je-donner") != -1) {
		import(
			/* webpackChunkName: "PagePuisJeDonner"*/ "../PagePuisJeDonner/index.js"
		);
	}

	if (url.toLowerCase().indexOf("/evaluer-application") != -1) {
		import(/* webpackChunkName: "PageEval"*/ "../PageEval/index.js");
	}

	if (url.toLowerCase().indexOf("/mes-rendez-vous") != -1) {
		import(/* webpackChunkName: "PageMesRDV"*/ "../PageMesRDV/index.js");
	}

	if (url.toLowerCase().indexOf("/mes-dons") != -1) {
		LeftMenuHeight();
	}

	if (url.toLowerCase().indexOf("/me-connecter") != -1) {
		import(
			/* webpackChunkName: "PageMeConnecter"*/ "../PageMeConnecter/index.js"
		);
	}

	if (url.toLowerCase().indexOf("/type-de-don") != -1) {
		import(/* webpackChunkName: "PageTypeDon"*/ "../PageTypeDon/index.js");
	}
	//Création d'un bouton d'installation pour PWA Android seulement
	if (url.toLowerCase().indexOf("/ajouter-ecran-accueil") != -1) {
		AndroidPWABtnCreation();
	}

	if (url.toLowerCase().indexOf("/maintenance") != -1) {
		import(
			/* webpackChunkName: "PageMaintenance"*/ "../PageMaintenance/index.js"
		);
	}

	if (
		url.toLowerCase().indexOf("/conditions-utilisation-et-confidentialite") !=
		-1
	) {
		import(/* webpackChunkName: "PageConditions"*/ "../PageCondition/index.js");
	}

	//On teste si on a un message de prise de rdv par le site web
	//si oui in affiche le modal

	if ($.urlParam("rdv") != null) {
		var rdvParams = $.urlParam("rdv");
		try {
			var rdvVal = new TextDecoder()
				.decode(base64ToBytes(rdvParams))
				.split("&");
			var code = rdvVal[0].split("=")[1];
			var date = rdvVal[1].split("=")[1];
			var type = rdvVal[2].split("=")[1].toLowerCase();
			if (
				code.length == 5 &&
				(type == "plasma" || type == "sang" || type == "plaquette" || type == "plaquettes")
			) {
				//$("#infoRdvText").text(
				//	"Vous avez pris rendez-vous par le site web d'Héma-Québec, pour continuer vous devez vous connecter à notre application ou créer un compte."
				//);
				var rdvDate = moment(date, "YYYYMMDD-HHmm");
				if (rdvDate > Date.now()) {
					$("#infoRdvModal").modal("show");
				} else {
					$('#rdvok').addClass('d-none');
					$('#rdvTitleOk').addClass('d-none');
					$('#rdvbadtoken').removeClass('d-none');
					$('#rdvTitleError').removeClass('d-none');
					//affiche token invalide
					$("#infoRdvModal").modal("show");
				}
				
			}
		} catch (error) {
			$('#rdvok').addClass('d-none');
			$('#rdvTitleOk').addClass('d-none');
			$('#rdvbadtoken').removeClass('d-none');
			$('#rdvTitleError').removeClass('d-none');
			//affiche token invalide
			$("#infoRdvModal").modal("show");
		}
	}
}
window.PageRun = PageRun;

function base64ToBytes(base64) {
	const binString = atob(base64);
	return Uint8Array.from(binString, (m) => m.codePointAt(0));
}
window.base64ToBytes = base64ToBytes;
